// extracted by mini-css-extract-plugin
export default {"errorMessage":"Messages_errorMessage__vk3qA","mainError":"Messages_mainError__HwiVY","subError":"Messages_subError__08u1O"};